<h2 mat-dialog-title class="title">
    {{ title }}
    <button mat-icon-button class="close-btn" (click)="dialogRef.close('cancel')" aria-label="Close">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<div mat-dialog-content class="dialog-body">
    <p class="subtitle">{{ description }}</p>

    <div class="section-label">Suggested hints</div>
    <div class="preset-chips" *ngIf="commonPrompts?.length">
        <button type="button" class="preset-chip" *ngFor="let p of commonPrompts | slice:0:8"
            (click)="!isSelected(p.promptText) && addSuggestion(p.promptText)"
            [class.disabled]="isSelected(p.promptText)">
            <mat-icon class="plus">add</mat-icon>
            <span class="chip-text">{{p.promptText}}</span>
        </button>
    </div>

    <div class="instructions-box">
        <div class="toolbar">
            <div class="left">
                <span class="hint-title">Your selected hints</span>
                <span class="hint-count">{{instructions.length}}/{{max}}</span>
            </div>
            <button mat-button class="clear-btn" (click)="clearInstructions()"
                [disabled]="instructions.length === 0">Clear all</button>
        </div>
        <div class="selected-chips" *ngIf="instructions.length">
            <span class="selected-chip" *ngFor="let ins of instructions; let i = index">
                <span class="chip-text">{{ins}}</span>
                <button mat-icon-button class="remove-btn"
                    (click)="removeInstruction(i)"><mat-icon>close</mat-icon></button>
            </span>
        </div>

        <div class="input-row">
            <mat-form-field appearance="outline" class="grow">
                <input matInput [(ngModel)]="newInstruction" placeholder="Add an instruction and press Enter"
                    (keydown.enter)="$event.preventDefault(); addInstruction()">
            </mat-form-field>
            <button mat-stroked-button color="primary" class="add-btn" (click)="addInstruction()"
                [disabled]="!(newInstruction||'').trim().length">
                <mat-icon>add</mat-icon>
                <span> Add</span>
            </button>
        </div>
        <div class="hint">You can add up to {{max}} instructions. These are optional.</div>
    </div>
</div>

<div mat-dialog-actions class="actions-btns center">
    <button mat-flat-button color="primary" class="primary-cta" (click)="onPrimaryRegenerate()">Regenerate</button>
</div>